import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { AnalyticsPeriod } from '../../../../hooks/useBoardAnalytics';

interface KpiCardsProps {
  kpis: AnalyticsPeriod['kpis'];
}

interface KpiItem {
  label: string;
  value: string | number;
  delta?: number;
  suffix?: string;
}

function DeltaBadge({ delta }: { delta: number }) {
  if (delta > 0) return (
    <span className="kpi-delta kpi-delta--up">
      <TrendingUp size={12} /> +{delta}
    </span>
  );
  if (delta < 0) return (
    <span className="kpi-delta kpi-delta--down">
      <TrendingDown size={12} /> {delta}
    </span>
  );
  return <span className="kpi-delta kpi-delta--flat"><Minus size={12} /> 0</span>;
}

export default function KpiCards({ kpis }: KpiCardsProps) {
  const items: KpiItem[] = [
    { label: 'Jobs saved',         value: kpis.total_jobs,            delta: kpis.total_jobs_delta },
    { label: 'Activities',         value: kpis.total_activities,      delta: kpis.total_activities_delta },
    { label: 'Contacts linked',    value: kpis.contacts_linked },
    { label: 'Notes',              value: kpis.notes_count,           delta: kpis.notes_count_delta },
    { label: 'Activities done',    value: kpis.pct_completed_activities, suffix: '%' },
    { label: 'Avg activities/job', value: kpis.avg_activities_per_job },
  ];

  return (
    <div className="kpi-grid">
      {items.map((item) => (
        <div key={item.label} className="kpi-card">
          <div className="kpi-card__label">{item.label}</div>
          <div className="kpi-card__value">
            {item.value}{item.suffix ?? ''}
          </div>
          {item.delta !== undefined && (
            <div className="kpi-card__footer">
              <DeltaBadge delta={item.delta} />
              <span style={{ color: '#9ca3af' }}>vs prev period</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
